'use client';

import { Package } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useRepScoreStore } from '@/presentation/hooks/useStores';
import {
  ScoreCard,
  StatusTile,
  EarnRows,
  DrawerWhy,
  DrawerCTA,
  DEFAULT_DRAWER_WHY_COPY,
} from '../shared';

interface NewUserStateProps {
  /** Closes the drawer when the user taps "Got it" */
  onStartPlan?: () => void;
}

const NEXT_TIER_SCORE = 250;

/**
 * STATE 1: New User (low score with no meaningful repayment history)
 *
 * Mirrors Pencil frame `g5NrLX`. Leads with the Early Pickup benefit and a
 * warm lavender status tile.
 */
export const NewUserState = observer(function NewUserState({
  onStartPlan,
}: NewUserStateProps) {
  const repScoreStore = useRepScoreStore();
  const score = repScoreStore.currentScore;

  return (
    <div className="flex flex-col gap-[18px]">
      <ScoreCard
        score={score}
        tier="starter"
        helper="New to Motito. Every on-time payment builds your trust level."
        progressToScore={NEXT_TIER_SCORE}
      />

      <StatusTile
        variant="info"
        icon={<Package className="size-4 text-white" />}
        title="Early Pickup not eligible yet"
        body="Keep paying on time. We'll let you know when you qualify."
      />

      <EarnRows />

      <DrawerWhy body={DEFAULT_DRAWER_WHY_COPY} />

      <DrawerCTA label="Got it" onClick={onStartPlan} />
    </div>
  );
});

export default NewUserState;
